import { RecipientDetailsContainer } from 'src/containers';

export const RecipientDetails = () => <RecipientDetailsContainer />;
